import { setDTPageAttributes } from "../../../shared/analytics/dynatrace";
import { DT_ATTRIBUTES } from "../../../shared/constants/dynatrace";

/**
 * Set Dynatrace custom attributes that are specific to the stream
 * @param {Object} streamInfo
 * @param {boolean} isDynatraceTrackingEnabled
 */
export const setVideoStreamAttributes = (streamInfo, isDynatraceTrackingEnabled) => {
  if (streamInfo) {
    setDTPageAttributes({ [DT_ATTRIBUTES.LICENSE_URL]: streamInfo.licenseURL }, isDynatraceTrackingEnabled);
    setDTPageAttributes({ [DT_ATTRIBUTES.DRM_TOKEN]: streamInfo.authToken }, isDynatraceTrackingEnabled);
  }
};

/**
 * Reset Dynatrace custom attributes that are asset-specific
 */
export const resetPlayerAttributes = (isDynatraceTrackingEnabled) => {
  // Clean up Dynatrace custom attributes
  setDTPageAttributes({ [DT_ATTRIBUTES.PROGRAM_NAME]: null }, isDynatraceTrackingEnabled);
  setDTPageAttributes({ [DT_ATTRIBUTES.SERIES_NAME]: null }, isDynatraceTrackingEnabled);
  setDTPageAttributes({ [DT_ATTRIBUTES.DRM_TOKEN]: null }, isDynatraceTrackingEnabled);
  setDTPageAttributes({ [DT_ATTRIBUTES.LICENSE_URL]: null }, isDynatraceTrackingEnabled);
};

/**
 * Determine the Dynatrace content type based on the provided parameters
 * @param {string} contentType
 * @param {boolean} isLookbackStream
 * @param {Object} isRestartedStream
 * @returns {string} Dynatrace content type
 */
export const getDTContentType = (contentType, isLookbackStream, isRestartedStream) => {
  return contentType !== "LIVE"
    ? contentType
    : isLookbackStream
    ? "LOOKBACK"
    : isRestartedStream.current
    ? "RESTART"
    : "LIVE";
};
